import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { ICalendarAppState } from '../redux-state';
import { applyPromoCode } from '../redux-state/actions/calendar-api.actions';

import MonthSelectionDropdownView from 'month-selection-dropdown.view';
import { ICalendarAppText } from '../custom/classes/calendar-text';

import { updatePromoCodeString } from '../redux-state/actions/promo-code.actions';
import { waitForImage, imageHasLoaded } from '../redux-state/actions/lazy-load.actions';

interface IExternalProps {
    src: string;
}

interface StateToProps {
    imageIsLoaded: boolean;
}

interface DispatchToProps {
    waitForImage: () => void;
    signalImageLoad: () => void;
}

export type LazyImageProps = IExternalProps & StateToProps & DispatchToProps & React.ImgHTMLAttributes<HTMLImageElement>;

export class LazyImageBase extends React.Component<LazyImageProps, null> {
    constructor(props: LazyImageProps) {
        super(props);

        props.waitForImage();
    }

    render() {
        const { imageIsLoaded, waitForImage, signalImageLoad, ...rest } = this.props;

        return (
            <img onLoad={signalImageLoad.bind(this)} {...rest} data-img-loaded={imageIsLoaded} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IExternalProps): StateToProps {
    return {
        imageIsLoaded: state.lazyLoad.imageHasLoaded[ownProps.src],
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: LazyImageProps): DispatchToProps {
    return {
        waitForImage: () => dispatch(waitForImage(ownProps.src)),
        signalImageLoad: () => dispatch(imageHasLoaded(ownProps.src))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(LazyImageBase);